import request from "../helpers/request";

export const register = async (data) => {
  const response = await request.post(`/account/signup/`, data);
  return response.data;
};

export const login = async (data) => {
  const response = await request.post(`/account/signin/`, data);
  return response.data;
};

export const authUser = async (token) => {
  const response = await request.get("/account/me/", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};


export const updateUser = async (token, userData) => {
  const response = await request.patch("/account/user/", userData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const setUserPassword = async (token, passwordData) => {
  const response = await request.post("/account/user-set-password/", passwordData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
